<template>
  <section id="sl-login">
    <div v-if="busy" class="loading loading-xl"></div>
    <div class="card" v-else>
      <div class="card-body">
        <form @submit="doSignIn">
          <div class="form-group">
            <div class="input-group">
              <input type="password" v-model="password" class="form-input" ref="password" autocomplete="current-password">
              <button class="btn btn-primary input-group-btn" @click.stop="doSignIn">Sign In</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Login',
  data () {
    return {
      busy: false,
      password: ''
    }
  },
  methods: {
    async doSignIn () {
      this.busy = true
      if (!this.password) {
        this.busy = false
        return
      }

      if (await this.signIn({ key: this.password })) {
        this.getInitialData()
        this.busy = false
        this.$router.push('/')
        return
      }
      setTimeout(() => {
        this.busy = false
        this.$nextTick(() => {
          this.$refs['password'].focus()
        })
      }, 200)
    }
  }
}
</script>

<style lang="scss">
  @import '../assets/_vars';

  #sl-login {
    .card {
      max-width: 50%;
      margin: 3rem auto;

      @media screen and (max-width: 767px) {
        margin: 1rem auto;
        max-width: 75%;
      }

      @media screen and (max-width: 480px) {
        margin: 0.5rem auto;
        max-width: 100%;
      }

      .card-body {
        padding: 0.5rem;
      }
    }
  }
</style>
